/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React from "react";
import classes from "../reports.module.css";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Pagination from "@mui/material/Pagination";
import { Select } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import { withTranslation } from "react-i18next";
import currencyFormatter from "../../../../helper/currencyFormatter";
import { formatNumber } from "../../../../helper/numberFormatter";
import { formatDate } from "../../../../helper/dateFormatter";

const BillingHistoryTable = (props) => {
  const t = props.t;
  return (
    <div className={classes.root}>
      <TableContainer>
        {/* <Table className={classes.table} aria-label="simple table"> */}
        <Table className={"newGlobalTable"} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell
                className="global-custom-sorting-header"
                onClick={(e) => {
                  props.updateSorting("orderId");
                }}
              >
                <b>{t("ORDER_ID")}</b>
                {/* Sort indication */}
                {props.sortBy === "orderId" ? (
                  <span className="material-icons">
                    {props.sortOrder === "DESC" ? "expand_less" : "expand_more"}
                  </span>
                ) : (
                  <span className="material-icons sorting-indicator-icon">
                    unfold_more
                  </span>
                )}
              </TableCell>
              <TableCell
                className="global-custom-sorting-header"
                onClick={(e) => {
                  props.updateSorting("itemDescription");
                }}
              >
                <b>{t("PRODUCT_NAME")}</b>
                {/* Sort indication */}
                {props.sortBy === "itemDescription" ? (
                  <span className="material-icons">
                    {props.sortOrder === "DESC" ? "expand_less" : "expand_more"}
                  </span>
                ) : (
                  <span className="material-icons sorting-indicator-icon">
                    unfold_more
                  </span>
                )}
              </TableCell>
              <TableCell
                className="global-custom-sorting-header"
                onClick={(e) => {
                  props.updateSorting("featureCode");
                }}
              >
                <b>{t("PRODUCT_CODE")}</b>
                {/* Sort indication */}
                {props.sortBy === "featureCode" ? (
                  <span className="material-icons">
                    {props.sortOrder === "DESC" ? "expand_less" : "expand_more"}
                  </span>
                ) : (
                  <span className="material-icons sorting-indicator-icon">
                    unfold_more
                  </span>
                )}
              </TableCell>
              <TableCell
                className="global-custom-sorting-header"
                onClick={(e) => {
                  props.updateSorting("groupName");
                }}
              >
                <b>{t("CUSTOMER_NAME")}</b>
                {/* Sort indication */}
                {props.sortBy === "groupName" ? (
                  <span className="material-icons">
                    {props.sortOrder === "DESC" ? "expand_less" : "expand_more"}
                  </span>
                ) : (
                  <span className="material-icons sorting-indicator-icon">
                    unfold_more
                  </span>
                )}
              </TableCell>
              {props.providerType === "SALES_CHNL_PROVIDER" && (
                <TableCell
                  className="global-custom-sorting-header"
                  onClick={(e) => {
                    props.updateSorting("externalId");
                  }}
                >
                  <b>{t("CUSTOMER_BAN")}</b>
                  {/* Sort indication */}
                  {props.sortBy === "externalId" ? (
                    <span className="material-icons">
                      {props.sortOrder === "DESC"
                        ? "expand_less"
                        : "expand_more"}
                    </span>
                  ) : (
                    <span className="material-icons sorting-indicator-icon">
                      unfold_more
                    </span>
                  )}
                </TableCell>
              )}
              <TableCell
                className="global-custom-sorting-header"
                onClick={(e) => {
                  props.updateSorting("attrValue");
                }}
              >
                <b>{t("AGENT_ID")}</b>
                {/* Sort indication */}
                {props.sortBy === "attrValue" ? (
                  <span className="material-icons">
                    {props.sortOrder === "DESC" ? "expand_less" : "expand_more"}
                  </span>
                ) : (
                  <span className="material-icons sorting-indicator-icon">
                    unfold_more
                  </span>
                )}
              </TableCell>
              <TableCell
                className="global-custom-sorting-header"
                onClick={(e) => {
                  props.updateSorting("paymentType");
                }}
              >
                <b>{t("CHARGE_TYPE")}</b>
                {/* Sort indication */}
                {props.sortBy === "paymentType" ? (
                  <span className="material-icons">
                    {props.sortOrder === "DESC" ? "expand_less" : "expand_more"}
                  </span>
                ) : (
                  <span className="material-icons sorting-indicator-icon">
                    unfold_more
                  </span>
                )}
              </TableCell>
              <TableCell
                className="global-custom-sorting-header"
                onClick={(e) => {
                  props.updateSorting("numberOfUnits");
                }}
              >
                <b>{t("QUANTITY")}</b>
                {/* Sort indication */}
                {props.sortBy === "numberOfUnits" ? (
                  <span className="material-icons">
                    {props.sortOrder === "DESC" ? "expand_less" : "expand_more"}
                  </span>
                ) : (
                  <span className="material-icons sorting-indicator-icon">
                    unfold_more
                  </span>
                )}
              </TableCell>
              <TableCell
                className="global-custom-sorting-header"
                onClick={(e) => {
                  props.updateSorting("ratePerUnit");
                }}
                align="right"
              >
                {/* Sort indication */}
                {props.sortBy === "ratePerUnit" ? (
                  <span className="material-icons">
                    {props.sortOrder === "DESC" ? "expand_less" : "expand_more"}
                  </span>
                ) : (
                  <span className="material-icons sorting-indicator-icon">
                    unfold_more
                  </span>
                )}
                <b>{t("RATE_PER_UNIT")}</b>
              </TableCell>
              <TableCell
                className="global-custom-sorting-header"
                onClick={(e) => {
                  props.updateSorting("totalCharge");
                }}
                align="right"
              >
                {/* Sort indication */}
                {props.sortBy === "totalCharge" ? (
                  <span className="material-icons">
                    {props.sortOrder === "DESC" ? "expand_less" : "expand_more"}
                  </span>
                ) : (
                  <span className="material-icons sorting-indicator-icon">
                    unfold_more
                  </span>
                )}
                <b>{t("TOTAL")}</b>
              </TableCell>
              <TableCell
                className="global-custom-sorting-header"
                onClick={(e) => {
                  props.updateSorting("createdStamp");
                }}
                align="right"
              >
                {/* Sort indication */}
                {props.sortBy === "createdStamp" ? (
                  <span className="material-icons">
                    {props.sortOrder === "DESC" ? "expand_less" : "expand_more"}
                  </span>
                ) : (
                  <span className="material-icons sorting-indicator-icon">
                    unfold_more
                  </span>
                )}
                <b>{t("DATE")}</b>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {/* Show orders list */}
            {props.list.map((row, index) => (
              <TableRow
                key={index}
                className={classes.rowClass}
                style={{ cursor: "default" }}
                // onClick={(e) => { navigate(`/order/${row.orderId}`) }}
              >
                <TableCell>{row.orderId}</TableCell>
                <TableCell>{row.productName}</TableCell>
                <TableCell>{row.featureCode}</TableCell>
                <TableCell>{row.customerName}</TableCell>
                {props.providerType === "SALES_CHNL_PROVIDER" && (
                  <TableCell>{row.customerBan}</TableCell>
                )}
                <TableCell>{row.agentId}</TableCell>
                <TableCell>{row.chargeType}</TableCell>
                <TableCell>{row.numberOfUnits}</TableCell>
                <TableCell align="right">
                  {currencyFormatter(row.ratePerUnit)}
                </TableCell>
                <TableCell align="right">
                  {currencyFormatter(row.total)}
                </TableCell>
                <TableCell align="right">
                  {/* {props.convertDate(row.createdStamp)} */}
                  {formatDate(row.createdStamp)}
                </TableCell>
              </TableRow>
            ))}
            {/* If there is no orders to show */}
            {props.list.length === 0 && (
              <TableRow>
                <TableCell colSpan={12} align="center">
                  {t("NO_ORDER_FOUND")}
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {props.totalHistoryCount > 0 && (
        <div
          className="global-custom-pagination"
          style={{ background: "rgba(196, 196, 196, 0.2)" }}
        >
          <label style={{ float: "left", padding: "5px" }}>
            {t("TOTAL_RECORDS")}: {formatNumber(props.totalHistoryCount)}
          </label>
          <label>
            {t("ROWS_PER_PAGE")}:
            <Select
              value={props.rowsPerPage}
              onChange={props.handleChangeRowsPerPage}
            >
              <MenuItem value={10}>10</MenuItem>
              <MenuItem value={50}>50</MenuItem>
              <MenuItem value={100}>100</MenuItem>
            </Select>
          </label>
          <Pagination
            count={Math.ceil(props.totalHistoryCount / props.rowsPerPage)}
            onChange={props.handleChangePage}
            page={props.page}
            showFirstButton
            showLastButton
          />
        </div>
      )}
    </div>
  );
};

export default withTranslation("translations")(BillingHistoryTable);
